import React from "react";
import "../Styles/Parallax.css";

const Parallax = ({ background, heading, description }) => {
  return (
    <div
      className="parallax-section"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="parallax-content">
        <h2>{heading}</h2>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default Parallax;
